import React from "react";
import "@abb/abb-common-ux-react/styles.css";
import "./shared.sass";
import { Input, Icon, Button } from "@abb/abb-common-ux-react";
import { Translation } from "react-i18next";
import { LABEL_SELECT_FILTER } from "../../utilities/Constants";
import SidebarTrend from "./SidebarTrend";
import { ITrendViewData } from "../../models/trends/TrendViewData";
import { ABB_CLOSE } from "../../utilities/IconConstants";
import * as CONSTANTS from "../../utilities/Constants";
import ISourceFormData from "../../models/source/SourceFormData";
import { ISourceViewData } from "../../models/source/SourceViewData";

interface ISidebarLayoutProp<> {
  handlePanelToggle?: () => void;
  isFullSidebarVisible?: boolean;
  children?: any;
  isShowSelectFilter?: boolean;
  isShowTrends?: boolean;
  selectedDateRange?: any[];
  dateRangeChangeHandler?: (val: any) => any;
  setTrendCustomFromDate?: (val: any) => any;
  setTrendCustomToDate?: (val: any) => any;
  selectFromDate?: any[];
  selectToDate?: any[];
  daterange?: any[];
  selectedGrade?: any[];
  GradeChangeHandler?: (val: any) => any;
  trendDropdownGradeList?: ITrendViewData[];
  selectedProduct?: any[];
  ProductChangeHandler?: (val: any) => any;
  trendDropdownProductList?: ITrendViewData[];
  selectedSample?: any[];
  SampleChangeHandler?: (val: any) => any;
  trendDropdownSampleList?: ITrendViewData[];
  listData?: any[];
  clearAllFilters?: () => void;
  reSet?: () => void;
  showSelectFilterHandler?: () => void;
  showFilter?: boolean;
  hasFiltersChanged?: boolean;
  //Source
  selectedSource: any[];
  SourceChangeHandler?: (val: any) => any;
  trendDropdownSourceList: ISourceViewData[];
  loadingProperties?: boolean;
}

class SidebarLayout extends React.Component<ISidebarLayoutProp, {}> {
  _parentCallback: any[];
  constructor(props: ISidebarLayoutProp) {
    super(props);
    this.state = {};
  }
  public render() {
    return (
      <Translation>
        {(t) => (
          <React.Fragment>
            {this.props.isFullSidebarVisible ? (
              <div
                className="sidebar-layout sidebar-align sidenav nav-main rounded-sm rounded-lg p-2 float-left"
                style={{ zIndex: 1 }}
              >
                <React.Fragment>
                  <div className="row">
                    <div className="col-3">
                      <button
                        title={t("Collapse")}
                        className="icon-button circle "
                        onClick={this.props.handlePanelToggle}
                      >
                        <Icon name="abb/caret-left" sizeClass="medium" />
                      </button>
                    </div>
                    <div className="col-5 no-padding mb-0">
                      {this.props.isShowSelectFilter ? (
                        <p className="sidebar-main-title font-weight-bold ">
                          {t(LABEL_SELECT_FILTER)}
                        </p>
                      ) : null}
                    </div>
                    <div className="col-1">
                      {!this.props.showFilter &&
                        this.props.hasFiltersChanged && (
                          <Icon
                            name="abb/close"
                            sizeClass="small"
                            onClick={this.props.reSet}
                            style={{ padding: "4px" }}
                          />
                        )}
                    </div>
                    <div className="col-2 mt-1">
                      {this.props.isShowSelectFilter ? (
                        <div>
                          {this.props.hasFiltersChanged && (
                            <span className="dots"></span>
                          )}
                          <Icon
                            className={
                              this.props.showFilter ? "filter-circle" : ""
                            }
                            name="abb/filter"
                            sizeClass="small"
                            onClick={this.props.showSelectFilterHandler}
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>

                  {this.props.isShowTrends ? (
                    <div className="trend-sidebar-details">
                      <hr className="hr-line" />
                      <SidebarTrend
                        selectedDateRange={this.props.selectedDateRange}
                        dateRangeChangeHandler={
                          this.props.dateRangeChangeHandler
                        }
                        setTrendCustomFromDate={
                          this.props.setTrendCustomFromDate
                        }
                        setTrendCustomToDate={this.props.setTrendCustomToDate}
                        selectFromDate={this.props.selectFromDate}
                        selectToDate={this.props.selectToDate}
                        daterange={this.props.daterange}
                        selectedGrade={this.props.selectedGrade}
                        GradeChangeHandler={this.props.GradeChangeHandler}
                        trendDropdownGradeList={
                          this.props.trendDropdownGradeList
                        }
                        selectedProduct={this.props.selectedProduct}
                        ProductChangeHandler={this.props.ProductChangeHandler}
                        trendDropdownProductList={
                          this.props.trendDropdownProductList
                        }
                        selectedSample={this.props.selectedSample}
                        SampleChangeHandler={this.props.SampleChangeHandler}
                        trendDropdownSampleList={
                          this.props.trendDropdownSampleList
                        }
                        selectedSource={this.props.selectedSource}
                        trendDropdownSourceList={
                          this.props.trendDropdownSourceList
                        }
                        SourceChangeHandler={this.props.SourceChangeHandler}
                        loadingProperties={this.props.loadingProperties}
                      />

                      <div className="drawer-header-bg-2 mt-2">
                        {this.props.children}
                      </div>
                      <div
                        className="clear-filter"
                        onClick={this.props.clearAllFilters}
                      >
                        <Icon name={ABB_CLOSE} />{" "}
                        {t(CONSTANTS.CLEAR_ALL_FILTERS)}{" "}
                      </div>
                    </div>
                  ) : (
                    <div className="drawer-header-bg mt-2">
                      {this.props.children}
                    </div>
                  )}
                </React.Fragment>
              </div>
            ) : (
              <div
                onClick={this.props.handlePanelToggle}
                className="p-3 rounded sidebar-shrink"
              >
                <Icon
                  name="abb/caret-right"
                  sizeClass="medium"
                  className="mt-1"
                />
              </div>
            )}
          </React.Fragment>
        )}
      </Translation>
    );
  }
}

export default SidebarLayout;
